import { Navigate, createFileRoute } from "@tanstack/react-router";
import { TransactionsWorkspace } from "../components/admin/transactions-workspace";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/transactions")({ component: AdminTransactionsPage });

function AdminTransactionsPage() {
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return <TransactionsWorkspace />;
}
